import type { ReportBlock, ReportOutput } from "@/profitability/types";

/** One tab of a report's output. */
export interface ReportPane {
  id: string;
  title: string;
  surface: "analysis" | "review" | "records";
  dataset?: string;
  count?: number;
  blocks: ReportBlock[];
}

export const reportPanes = (output: ReportOutput): ReportPane[] =>
  (output.panes ?? [])
    .map(({ id, title, surface = "analysis", dataset }) => ({
      id,
      title,
      surface,
      dataset,
      count: dataset
        ? output.datasets.find((item) => item.id === dataset)?.rows.length
        : undefined,
      blocks: output.blocks.filter((block) => block.pane === id),
    }))
    // A pane the script declared and then put nothing on is an empty tab,
    // which is only ever a mistake in the making of the report.
    .filter((pane) => pane.blocks.length);

export const RUN_DOCUMENTS_TAB = "documents";

/**
 * A run's tabs: its panes, then its workbook once one is built, then the
 * documents it read. The run page's strip and the nav column list the same.
 */
export const runTabs = ({
  output,
  workbookTab,
  sheet,
  documents,
}: {
  output: ReportOutput;
  workbookTab: string;
  sheet: boolean;
  documents: boolean;
}) => [
  ...reportPanes(output).map(({ id, title }) => ({ id, title })),
  ...(sheet ? [{ id: workbookTab, title: "Sheet" }] : []),
  ...(documents ? [{ id: RUN_DOCUMENTS_TAB, title: "Documents" }] : []),
];
